export interface Patient {
  name?: string;
  first_name: string;
  last_name: string;
  mobile: string;
  email: string;
  communication_preferences: string[];
  date_of_birth: string;
  finger_print: string;
  preferred_language: string;
  tenant: string;
  platform: LoginSignupPlatform;
}

export interface Signup {
  patient?: Patient;
  participant?: Patient;
}

export enum LoginSignupPlatform {
  app = 'app',
  browser = 'browser',
}

export enum SignupLoginOption {
  email = 'email',
  mobile = 'mobile',
}
